import { motion } from 'framer-motion';

const FAQHero = () => {
  return (
    <section className="relative pt-36 md:pt-40 pb-12 md:pb-20 overflow-hidden bg-[#0A1628]">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/93ef3c518704263b2d58f963696c79a0.jpg)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628]/80 via-[#0A1628]/70 to-[#0A1628]" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 bg-[#D4AF37]/20 border border-[#D4AF37]/30 text-[#D4AF37] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-[10px] md:text-xs font-bold tracking-wider mb-4 md:mb-6"
        >
          <i className="ri-question-answer-line text-xs md:text-sm"></i>
          PERGUNTAS FREQUENTES
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display font-extrabold text-3xl md:text-4xl lg:text-6xl text-white leading-tight mb-4 md:mb-6"
        >
          Tire Suas Dúvidas sobre{' '}
          <span className="text-[#D4AF37]">AVCB, CLCB e Segurança</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="text-sm md:text-lg text-neutral-300 max-w-2xl mx-auto leading-relaxed"
        >
          Respondemos as dúvidas mais comuns sobre prevenção de incêndio, segurança do trabalho e regularização junto ao Corpo de Bombeiros.
        </motion.p>
      </div>
    </section>
  );
};

export default FAQHero;